import maximize from "./maximize";
import minimize from "./minimize";
import notifyResize from "./notify-resize";
import state from "./state";

/**
 * Creates a handler for postMessage events
 *
 * @param  {HTMLIFrameElement} iframe
 * @param  {HTMLElement} convo
 * @returns {Function} receiveMessage
 */
export default function createMessageReceiver(iframe, convo) {
  /**
   * Handler for messages from the `postMessage` API
   *
   * @param  {MessageEvent} event
   * @returns {void}
   */
  return function receiveMessage(event) {
    const { experienceId, origin, userId } = state.values;

    // filter out messages that are not from our iframe
    if (event.origin !== origin) {
      return;
    }

    if (event.data === "speakeasy:ready") {
      notifyResize(iframe);
    }

    if (event.data === "speakeasy:maximize") {
      maximize(iframe);

      document.dispatchEvent(
        new CustomEvent("speakeasy:open", {
          detail: { experienceId, userId }
        })
      );
    }

    if (event.data === "speakeasy:minimize") {
      minimize(iframe, convo);

      document.dispatchEvent(
        new CustomEvent("speakeasy:close", {
          detail: { experienceId, userId }
        })
      );
    }

    if (event.data.startsWith("speakeasy:notify")) {
      const [key, value] = event.data.split("=");
      const eventName = key.split(":").pop();
      document.dispatchEvent(
        new CustomEvent(`speakeasy:${eventName}`, {
          detail: Object.assign({ experienceId, userId }, JSON.parse(value))
        })
      );
    }
  };
}
